// extracted by mini-css-extract-plugin
export default {"brand":"brand_brand__xzDGz"};